export default __webpack_public_path__ + "static/media/whychooseBg.31e5dc8c.jpg";